exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-information-settings[data-v-8a80a548]{border-radius:2px;padding:11px 20px 11px 16px;border:1px dashed #ced0dc}.w-100[data-v-8a80a548]{width:100%}.relative[data-v-8a80a548]{position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8a80a548","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/additional/Addittional.vue
// module id = cc53516a22152244d668
// module chunks = 73